import { z } from "zod";
import { UserRole } from "@/generated/models";

/** Boundary validation for the load-bearing identity surface (`/me`). */
export const meSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  display_name: z.string(),
  role: z.nativeEnum(UserRole).catch(UserRole.MEMBER),
  default_org_id: z.string().nullable().default(null),
  email_verified: z.boolean().optional(),
  phone_verified: z.boolean().optional(),
  phone_redacted: z.string().nullable().optional(),
  /** Versioned path of their face (`/api/v1/users/{id}/avatar?v=`), or null. */
  avatar_url: z.string().nullable().optional(),
  /** upload / url / github / gravatar — where the face came from. */
  avatar_source: z.string().nullable().optional(),
});

export const organizationSummarySchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
});

export const authResponseSchema = z.object({
  access_token: z.string().optional(),
  refresh_token: z.string().optional(),
  token_type: z.string().optional(),
  expires_in: z.number().optional(),
  user: meSchema,
  organization: organizationSummarySchema.nullable().optional(),
});
